import * as tslib_1 from "tslib";
import { createStore } from '@souche-f2e/muji';
import { getState } from '@@/store';
import { fetchMenuList, addOneMenu, delOneMenu, updateOneMenu, updateSequence, } from '@/services/menu';
import { changeRespToRawMenu, createMenuData } from '@/shared/utils';
const state = {
    menuList: [],
    rawData: [],
};
export default createStore({
    state,
    reducers: {
        SET_MENU_LIST(state, payload) {
            state.menuList = payload;
        },
        SET_RAW_DATA(state, payload) {
            state.rawData = payload;
        },
    },
    effects: {
        loadMenuList() {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const resp = yield fetchMenuList().promise;
                const { sso: { userInfo: { resources } } } = getState().global;
                let resourcesArray = [];
                try {
                    resourcesArray = JSON.parse(resources);
                }
                catch (e) {
                    console.log(e);
                }
                const rawData = changeRespToRawMenu(resp);
                const menuList = createMenuData(rawData, resourcesArray);
                this.SET_RAW_DATA(rawData);
                this.SET_MENU_LIST(menuList);
            });
        },
        addOneMenu(payload) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield addOneMenu(payload).promise;
                yield this.loadMenuList();
            });
        },
        delOneMenu(payload) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield delOneMenu(payload).promise;
                yield this.loadMenuList();
            });
        },
        updateOneMenu(payload) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield updateOneMenu(payload).promise;
                yield this.loadMenuList();
            });
        },
        updateSequence(payload) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield updateSequence(payload).promise;
            });
        },
    },
});
